"use client";

import { useState } from "react";
import { LuExternalLink, LuPencil } from "react-icons/lu";
import { useEventContextV2, usePermissionsContext } from "~/app/providers";

import { Button } from "~/components/v3/themed/Button";
import { EditEventSheet } from "./EditEventSheet";
import Link from "next/link";
import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";
import { usePathname } from "next/navigation";

const EventCreatorActions = ({
    customization,
}: {
    customization?: CustomizableLayout;
}) => {
    const pathname = usePathname();
    const event = useEventContextV2();
    const permissions = usePermissionsContext();
    const [isEditEventSheetOpen, setIsEditEventSheetOpen] = useState(false);

    const isAllowedToEdit =
        permissions.isHost || permissions.isManager || permissions.isAdmin;

    if (!isAllowedToEdit) return null;

    return (
        <div className="mx-auto flex w-full gap-2 p-2">
            <Button
                variant="secondary"
                className={cn(
                    "flex w-full max-w-max items-center gap-2 text-sm md:w-auto",
                    customization?.buttons?.secondary,
                )}
                size="md"
                onClick={() => setIsEditEventSheetOpen(true)}
            >
                <LuPencil className="h-3 w-3" />
                <span>Edit event</span>
            </Button>
            <Link href={`${pathname}/manage`}>
                <Button
                    size="md"
                    variant="secondary"
                    className={cn(
                        "flex w-full items-center gap-2 md:w-auto",
                        customization?.buttons?.secondary,
                    )}
                >
                    <LuExternalLink className="h-3 w-3 font-semibold" />
                    <span>Event Management</span>
                </Button>
            </Link>

            <EditEventSheet
                isOpen={isEditEventSheetOpen}
                setIsOpen={setIsEditEventSheetOpen}
                event={event}
                customization={customization}
            />
        </div>
    );
};

export default EventCreatorActions;
